const results = [
  'более самостоятельные руководители;',
  'более понятная постановка задач;',
  'снижение микроменеджмента;',
  'повышение ответственности;',
  'более качественная обратная связь;',
  'более конструктивное решение конфликтов;',
  'развитие кадрового резерва;',
  'повышение самостоятельности сотрудников;',
  'единый управленческий язык;',
  'более системное управление изменениями;',
  'снижение зависимости бизнеса от отдельных руководителей;',
  'более последовательное развитие управленческой команды.',
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Потенциальные результаты развития управленческих компетенций. Мы не обещаем гарантированный финансовый результат — итог зависит от внедрения
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{r}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}